import React from 'react';
import ContactForm from '../components/contact/ContactForm';

const Contact = () => {
  return <ContactForm />;
};

export default Contact;
